/* eslint-disable no-console */
import styles from './../styles/contact-form.module.scss';
import React from 'react';
import { Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import axios from 'axios';
import swal from 'sweetalert2';

class Contacto extends React.Component {
  url =
    'https://outgoing-van.kiper.io/api/v1/forms/register?token=8xi8676Ic3S68w57ZFCB27ho1b1xa76R';
  state = {
    nombre: '',
    correo: '',
    telefono: '',
    errors: {
      nombre: '',
      correo: '',
      telefono: '',
    },
    validator: true,
  };
  errorsConst = {
    nombre: '',
    correo: '',
    telefono: '',
  };
  onFormSubmit = (event) => {
    event.preventDefault();
    axios
      .post(this.url, {
        nombre: this.state.nombre,
        correo: this.state.correo,
        telefono: this.state.telefono,
      })
      .then(
        (res) => {
          swal.fire('Gracias', 'Pronto nos pondremos en contacto contigo.', 'success');
          this.setState({
            nombre: '',
            correo: '',
            telefono: '',
            errors: {
              nombre: '',
              correo: '',
              telefono: '',
            },
            validator: true,
          });
        },
        (error) => {
          console.log(error.response.data.message);
          swal.fire('Ops', error.response.data.message, 'error');
        },
      );
  };
  handleInputChange = (event) => {
    const regexp = new RegExp(`^-?[0-9]*$`);
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });

    switch (name) {
      case 'nombre':
        this.errorsConst.nombre = value.length < 2 ? 'Es necesario ingresar un nombre' : '';
        break;
      case 'correo':
        this.errorsConst.correo =
          value.length < 5
            ? 'Ingresa un email valido'
            : !value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
              ? 'Ingresa un email valido'
              : '';
        break;
      case 'telefono':
        this.errorsConst.telefono =
          value.length < 8
            ? 'Caracteres insuficiente'
            : !regexp.test(value)
              ? 'Ingresa solo números'
              : '';
        break;
      default:
        break;
    }
    this.setState({
      errors: this.errorsConst,
    });
    console.log(this.state.errors);
    if (
      this.state.errors.nombre == '' &&
      this.state.errors.telefono == '' &&
      this.state.errors.correo == ''
    ) {
      this.setState({
        validator: true,
      });
    } else {
      this.setState({
        validator: true,
      });
    }
    console.log(this.state.errors);
  };
  render() {
    return (
      <div className="">
        <Form
          id="contacto"
          onSubmit={this.onFormSubmit}
          className={styles.formularioContacto + ' py-lg-5 px-lg-4 py-md-4 px-md-3 py-3 px-2'}
        >
          <FormGroup>
            <FormText className="">
              <h1 className={'my-2 text-center text-md-left'}>
                ¿Listo para vivir en Balvanera Querétaro?
              </h1>
              <p className={styles.subtitleForm + ' mt-3 mb-2'}>
                Conoce nuestra oferta con terrenos desde 400 m², déjanos tus datos y pronto nos
                pondremos en contacto contigo.
              </p>
            </FormText>
            <Label for="nombre"> </Label>
            <Input
              type="text"
              name="nombre"
              id="nombre"
              placeholder="NOMBRE COMPLETO"
              value={this.state.nombre}
              onChange={this.handleInputChange}
              className={this.state.errors.nombre != '' ? 'border-danger' : ''}
            />
            <div className={styles.textError}>
              <p
                className={
                  this.state.errors.nombre != ''
                    ? ' border-danger text-center text-danger'
                    : ' d-none'
                }
              >
                {this.state.errors.nombre}
              </p>
            </div>
            <Label for="correo"> </Label>
            <Input
              type="email"
              name="correo"
              id="email"
              placeholder="CORREO ELECTRÓNICO"
              value={this.state.correo}
              className={this.state.errors.correo != '' ? 'border-danger' : ''}
              onChange={this.handleInputChange}
            />
            <div className={styles.textError}>
              <p
                className={
                  this.state.errors.correo != ''
                    ? ' border-danger text-center text-danger'
                    : ' d-none'
                }
              >
                {this.state.errors.correo}
              </p>
            </div>
            <Label for="telefono"> </Label>
            <Input
              type="text"
              name="telefono"
              id="telefono"
              placeholder="TELÉFONO"
              value={this.state.telefono}
              className={this.state.errors.telefono != '' ? 'border-danger' : ''}
              onChange={this.handleInputChange}
            />
            <div className={styles.textError}>
              <p
                className={
                  this.state.errors.telefono != ''
                    ? ' border-danger text-center text-danger'
                    : ' d-none'
                }
              >
                {this.state.errors.telefono}
              </p>
            </div>
          </FormGroup>
          <div className={styles.containerEnviar + ' px-4 py-3'}>
            <Button
              disabled={
                !(
                  this.state.telefono &&
                  this.state.correo &&
                  this.state.nombre &&
                  this.state.errors.nombre.length == '' &&
                  this.state.errors.telefono.length == '' &&
                  this.state.errors.correo.length == ''
                )
              }
              className={styles.buttonEnviar + ' w-100 py-2'}
            >
              ENVIAR
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

export default Contacto;
